var axios = require('axios');

var axiosInstance = axios.create({
    baseURL: 'https://sylius-pub.wisetiger-three.co.uk',
    //baseURL: 'https://order.mcdoner.de',
});

module.exports = axiosInstance;